const Menu = [
    { header: 'Nadzorna Plošča' },
    {
        name: 'dashboard',
        title: 'Pregled dogodkov',
        icon: 'mdi-view-dashboard',
        path: '/pregled',
        group: 'dashboard',
        permissions: ['sobec-view-events'],
        top_level: true
    },
    /*{
        name: 'settings',
        title: 'Nastavitve',
        icon: 'mdi-cogs',
        path: '/nastavitve',
        group: 'settings',
        permissions: ['sobec-view-settings', 'sobec-update-settings'],
        top_level: true
    },*/
    {
        title: 'Članstvo TD',
        icon: 'mdi-clipboard-account',
        group:'clani',
        permissions: ['sobec-view-member', 'sobec-create-member'],
        items: [
            {
                name: 'members_list',
                title: 'Seznam članov',
                icon: 'mdi-account-group',
                path: '/seznam-clanov',
                permissions: ['sobec-view-member']
            },
            {
                name: 'add_member',
                title: 'Dodaj člana',
                icon: 'mdi-account-plus',
                path: '/dodaj-clana',
                permissions: ['sobec-create-member']
            }
        ]
    },

    {
        title: 'Članarina TD',
        icon: 'mdi-cash-multiple',
        group:'clanarina',
        permissions: ['sobec-view-membership-fee-payment', 'sobec-create-membership-fee-payment'],
        items: [
            {
                name: 'membership_fee_payments',
                title: 'Plačila',
                icon: 'mdi-cash-multiple',
                path: '/clanarina/seznam-placil',
                permissions: ['sobec-view-membership-fee-payment']
            },

            {
                name: 'add_membership_fee_payment',
                title: 'Plačilo članarine',
                icon: 'mdi-account-group',
                path: '/clanarina/dodaj-placilo',
                permissions: ['sobec-create-membership-fee-payment']
            },
        ]
    },
    {
        title: 'Uporabniki',
        icon: 'mdi-account-group',
        group:'uporabniki',
        permissions: ['sobec-view-user', 'sobec-create-user'],
        items: [
            {
                name: 'users_list',
                title: 'Seznam uporabnikov',
                icon: 'mdi-account-group',
                path: '/seznam-uporabnikov',
                permissions: ['sobec-view-user']
            },
            {
                name: 'add_user',
                title: 'Dodaj uporabnika',
                icon: 'mdi-account-plus',
                path: '/dodaj-uporabnika',
                permissions: ['sobec-create-user']
            }
        ]
    },
   
    /*{
        name: 'traffic_lights',
        title: 'Semaforji',
        icon: 'mdi-traffic-light',
        path: '/semaforji',
        group: 'traffic_lights',
    },*/

    /*{
        name: 'parking_barriers',
        title: 'Upravljanje zapornic',
        icon: 'mdi-remote',
        path: '/zapornice',
        group: 'parking_barriers',
    },*/

    /*{
        title: 'Najave',
        icon: 'mdi-tray-full',
        group: 'najave',
        permissions: ['sobec-view-announcement', 'sobec-create-announcement'],
        items: [
            {
                name: 'announcement_list',
                title: 'Seznam najav',
                icon: 'mdi-account-group',
                path: '/seznam-najav',
                permissions: ['sobec-view-announcement']
            },
            {
                name: 'add_announcement',
                title: 'Dodaj najavo',
                icon: 'mdi-account-plus',
                path: '/dodaj-najavo',
                permissions: ['sobec-create-announcement']
            }
        ]
    },*/

    {
        name: 'registration-numbers',
        title: 'Enkratni prehodi',
        icon: 'mdi-car-side',
        path: 'enkratni-prehodi/registrske-stevilke',
        group: 'vehicles',
        permissions: ['sobec-view-registration-number'],
        top_level: true
    },

    /*{
        name: 'parking_occupancy',
        title: 'Zasedenost parkirišča',
        icon: 'mdi-car-3-plus',
        path: 'zasedenost-parkirisca',
        group: 'parking_occupancy',
        permissions: ['sobec-view-parking-occupancy'],
        top_level: true
    },*/

    {
        title: 'Zapornice',
        icon: 'mdi-remote',
        group: 'zapornice', //group naziv mora biti enak kot  začetni path v router ... primer group: uporabniki, path: uporabniki/seznam ---> group: uporabniki == path: uporabniki/...
        permissions: ['sobec-parking-barriers'],
        items: [
            {
                name: 'parking_barriers_management',
                title: 'Upravljanje zapornic',
                icon: 'mdi-android-messages',
                path: '/zapornice/upravljanje',
                permissions: ['sobec-parking-barriers']
            },
            {
                name: 'parking_barriers_archive',
                title: 'Zgodovina',
                icon: 'mdi-android-messages',
                path: '/zapornice/arhiv',
                permissions: ['sobec-parking-barriers'],
            }
        ]
    },

    {
        name: 'exports',
        title: 'Izvoz podatkov',
        icon: 'mdi-application-export',
        path: 'izvoz-podatkov',
        group: 'exports',
        permissions: ['sobec-data-export'],
        //permissions: [],
        top_level: true
    },
]

export { Menu }